import React from 'react';
import DynamicFormsApp from './App';
import './styles.css';

export default function DynamicForms() {
  return (
    <div className="dynamicforms-page">
      <DynamicFormsApp />
    </div>
  );
}
